// src/tracker/components/KpiCard.js

import React from 'react';
import { Box, Card, CardContent, Typography, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  textAlign: 'left',
  padding: theme.spacing(1.5),
  borderRadius: 16,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'hidden',
  background:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(135deg, rgba(15, 23, 42, 0.9), rgba(2, 6, 23, 0.7))'
      : 'linear-gradient(135deg, #ffffff, #f8fafc)',
}));

// Accept a new optional prop: valueColor
const KpiCard = ({ title, value, subtitle, valueColor = 'text.primary', icon, accent = 'primary.main', loading = false }) => {
  return (
    <StyledCard>
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
          <Box>
            {loading ? (
              <>
                <Skeleton variant="text" width={120} height={20} />
                <Skeleton variant="text" width={160} height={36} />
                <Skeleton variant="text" width={140} height={18} />
              </>
            ) : (
              <>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  {title}
                </Typography>
                <Typography variant="h4" component="div" sx={{ fontWeight: 700, color: valueColor }}>
                  {value}
                </Typography>
                <Typography sx={{ mt: 0.5 }} color="text.secondary" variant="body2">
                  {subtitle}
                </Typography>
              </>
            )}
          </Box>
          {icon && !loading && (
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: 12,
                display: 'grid',
                placeItems: 'center',
                bgcolor: accent,
                color: 'white',
                boxShadow: '0 10px 18px rgba(0,0,0,0.25)',
              }}
            >
              {icon}
            </Box>
          )}
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default KpiCard;
